import { UnitOption, UIRoleOption } from '../types';

export const UNIT_OPTIONS: UnitOption[] = [
  { id: 1, label: 'Metric', value: 'METRIC' },
  { id: 2, label: 'Imperial', value: 'IMPERIAL' },
];

export const UI_ROLE_OPTIONS: UIRoleOption[] = [
  { id: 1, key: 'owner-editor', label: 'Owner - Editor', role: 'owner', permission: 'editor' },
  { id: 2, key: 'owner-viewer', label: 'Owner - Viewer', role: 'owner', permission: 'viewer' },
  { id: 3, key: 'member-editor', label: 'Editor', role: 'member', permission: 'editor' },
  { id: 4, key: 'member-viewer', label: 'Viewer', role: 'member', permission: 'viewer' },
];

export const NAVIGATION_ITEMS = [
  { key: 'company', label: 'Company Settings', isOwnerOnly: true },
  { key: 'personal', label: 'Personal Settings', isOwnerOnly: false },
  { key: 'users', label: 'Users', isOwnerOnly: true },
  { key: 'billing', label: 'Billing', isOwnerOnly: true },
] as const;

export const NAVIGATION_API_DEVELOPER_ITEM = {
  key: 'api',
  label: 'API / Developer',
  isOwnerOnly: false,
} as const;

export const NAVIGATION_LOCAL_ITEM = { key: 'local', label: 'Local Settings', isOwnerOnly: false };

export const API_BILLING_TIER_FLAG = 'api_usage_billing_tier';

export const MANAGE_API_STRIPE_FLAG = 'manage_api_stripe';

export const DEBOUNCE_DELAY = 500;

export const SCOPE_GLOBAL = 'GLOBAL';

export const SERVICE_ACCOUNT_EMAIL_SUFFIX = 'serviceaccount.com';

export const PREFERENCE_NAMES = {
  NAME: 'name',
  LAST_NAME: 'last_name',
  TITLE: 'title',
  UNITS: 'units',
  PHONE_NUMBER: 'phone_number',
  DISPLAY_NAME: 'display_name',
} as const;
